<template>
  <div class="cp-prize" @click="choosePrize">
    <div class="bg" :class="level">
      <div class="prize" :class="`prize-${prize}`">
        <div v-if="drawed" class="drawed"></div>
      </div>
    </div>
    <div v-if="!drawed && checked" class="checked"></div>
    <div class="name" :class="level">
      {{name}}
    </div>
  </div>
</template>

<script>

export default {
  name: 'team',
  props: {
    prize: {
      type: Number,
      default: () => 0
    },
    id: {
      type: Number,
      default: () => 0
    },
    name: {
      type: String,
      default: () => ''
    },
    drawed: {
      type: Number,
      default: 0
    },
    canDraw: {
      type: Boolean,
      default: false
    },
    choosed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    level() {
      if(this.prize >= 26) {
        return 'purple'
      }
      if([4,5,8,14,23,,24,25].includes(this.prize)) {
        return 'green'
      }
      if([3,7,10,13,15,20,21].includes(this.prize)) {
        return 'yellow'
      }
      return 'blue'
    }
  },
  data() {
    return {
      checked: false,
      canCheck: false
    }
  },
  mounted() {
    console.log(this.choosed);
    this.checked = this.choosed
  },
  watch: {
    choosed: {
      handler(value) {
        this.checked = value
      },
      immediate: true
    },
    canDraw: {
      handler(value) {
        this.canCheck = value
      },
      immediate: true
    }
  },
  methods: {
    choosePrize() {
      if(!this.canCheck && !this.checked) {
        return
      }
      this.checked = !this.checked;
      this.$emit("toggle", {
        checked: this.checked,
        id: this.id,
        icon: this.prize,
        name: this.name
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
  .cp-prize {
    width 1.27rem
    height 1.8rem
    margin -0.07rem 0 0 -0.1rem
    display block
    position relative
    .bg {
      position absolute
      top 0
      width 1.27rem
      height 1.27rem
      background: url('./images/blue.png') no-repeat
      background-size 1.27rem 1.27rem
      &.yellow {
        background-image: url('./images/yellow.png')
        background-size 0.96rem 0.96rem
        background-position center center
      }
      &.blue {
        background-image: url('./images/blue.png')
        background-size 0.96rem 0.96rem
        background-position center center
      }
      &.green {
        background-image: url('./images/green.png')
        background-size 1.27rem 38.1rem
        animation: auto-circle 2s steps(29) infinite;
      }
      &.purple {
        background-image: url('./images/purple.png')
        background-size 1.27rem 38.1rem
        animation: auto-circle 2s steps(29) infinite;
      }
    }
    .name {
      position absolute
      bottom 0.07rem
      width 0.88rem
      left 0.195rem
      height 0.44rem
      font-size 0.2rem
      font-weight bold
      line-height 0.22rem
      color #a25f38
      text-align center
      &.yellow {
        color: #a59b2a
      }
      &.blue {
        color: #4e6b9f
      }
      &.green {
        color: #367e29;
      }
      &.purple {
        color: #9e2c86
      }
    }
    .checked {
      position absolute
      top: 0.01rem
      right 0.05rem
      width 0.37rem
      height 0.37rem
      background-image: url('./images/checked.png')
      background-size contain
      background-position center center
      background-repeat no-repeat
      animation fadeIn 0.6s ease
    }
    .prize {
      width 0.7rem
      height 0.7rem
      background-position center center
      background-repeat no-repeat
      margin 0.28rem auto 0.31rem
      position relative
      background-size 0.7rem 0.7rem
      .drawed {
        position absolute
        top: 0
        left 0
        width 0.7rem
        height 0.7rem
        background-image: url('./images/drawed.png')
        background-size 0.66rem 0.65rem
        background-position center center
        background-repeat no-repeat
      }
      &-1, &-2, &-3, &-4 {
        background-image: url('./images/prize/1.png')
      }
      &-5 {
        background-image: url('./images/prize/5.png')
        background-size 0.55rem 0.62rem
        background-position center center
        transform: scale(1.2);
      }
      &-6, &-7, &-8 {
        background-image: url('./images/prize/6.png')
      }
      &-9, &-10 {
        background-image: url('./images/prize/9.png')
      }
      &-11, &-12, &-13, &-14 {
        background-image: url('./images/prize/11.png')
      }
      &-15, &-23 {
        background-image: url('./images/prize/15.png')
      }
      &-16, &-18, &-20, &-22, &-24 {
        background-image: url('./images/prize/16.png')
      }
      &-17, &-19, &-21, &-25 {
        background-image: url('./images/prize/17.png')
      }
      &-26 {
        background-image: url('./images/prize/26.png')
      }
      &-27 {
        background-image: url('./images/prize/27.png')
        background-size 0.46rem 0.53rem
        background-position center center
        transform: scale(1.2);
      }
      &-28 {
        background-image: url('./images/prize/28.png')
        transform: scale(1.5);
      }
      &-29 {
        background-image: url('./images/prize/29.png')
        background-size 0.7rem 0.61rem
        background-position center center
        transform: scale(1.15);
      }
      &-30 {
        background-image: url('./images/prize/30.png')
        background-size 0.56rem 0.7rem
        background-position center center
        transform: scale(1.15);
      }
      &-31 {
        background-image: url('./images/prize/31.png')
        background-size 0.69rem 0.63rem
        background-position center center
      }
      &-32 {
        background-image: url('./images/prize/32.png')
        background-size 0.68rem 0.57rem
        background-position center center
      }
      &-33 {
        background-image: url('./images/prize/33.png')
        background-size 0.7rem 0.59rem
        background-position center center
      }
    }
  }

  @keyframes auto-circle {
    to {
      background-position-y: -36.83rem;
    }
  }

  @keyframes fadeIn {
    from {
      opacity 0
    }
    to {
      opacity 1
    }
  }
</style>
